<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="title">Dream of Freedom</p>
<p class="title1">Michael Phillips</p>
<div class="break">
<p class="copy0">Copyright</p>
<p class="copy">Dream of Freedom</p>
<p class="copy1">Copyright © 2005 by Michael Phillips</p>
<p class="copy1">Cover art to the electronic edition copyright © 2012 by Bondfire Books, LLC.</p>
<p class="copy2">All rights reserved. No part of this book may be used or reproduced in any form or by any electronic or mechanical means, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer who may quote brief passages in a review.</p>
<p class="copy2">See full line of eBook originals at www.bondfirebooks.com.</p>
<p class="copy2">Author is represented by Alive Communications, Inc., 7680 Goddard St., Suite 200, Colorado Springs, CO 80920.</p>
<p class="copy2">Electronic edition published 2012 by Bondfire Books LLC, Colorado.</p>
<p class="copy1">ISBN e-Pub edition: 9780795326370</p>
<div class="break">
<p class="ded"><b>Dedication</b></p>
<blockquote>
<div>
<p class="tx1">To my dear friends Hans and Christa Peters, Marlies Borrmeister, and Anke Peters Clemens, with whom barriers of language have prevented the saying of much that draws individuals together in this world, but between whose hearts and mine pulses the greater language of sincere affection. That often-silent tongue of a common humanity and a shared Fatherhood has bound us together for more than 35 years (or, in Anke’s case, for a little over half that!). To call them my friends is one of the priceless possessions for which I feel most greatly blessed in this life. Both I and my family have through the years been as kindly welcomed with every courtesy and consideration back to that stately brick farmhouse in Graulingen, Suderburg in northern Germany as we have been into all of their hearts. It was there that Christa, Marlies, and I first began the adventure of a cross-cultural friendship more than three decades ago. To this place of my spiritual foundations I have often returned—for a day or two, a week or two, a month or two—a place far from home where God saw fit to stir the passions of a young man many years ago toward the wonder of a life of obedience to him, and to the vision of communicating that life through the written word. It is there, in a remarkable and peaceful three weeks, that the first draft of this book was substantially written, and to Hans, Christa, and Anke it is humbly and warmly dedicated.</p>
</div>
</blockquote>
<div class="break">
<p class="toc-ttl" id="toc">Contents</p>
<p class="toc1" id="t1"><a href="#/Introduction#c1">Introduction</a></p>
<p class="toc1" id="t2"><a href="#/Prologue#c2">Prologue: From the Old Books—Africa</a></p>
<p class="toc" id="t3"><a href="#/Prologue#c3">Out of the Unknown Past</a></p>
<p class="toc" id="t4"><a href="#/Dispersion#c4">Dispersion</a></p>
<p class="toc" id="t5"><a href="#/Freedom#c5">Freedom Stirs</a></p>
<p class="toc" id="t6"><a href="#/Deliverer#c6">Deliverer</a></p>
<p class="toc" id="t7"><a href="#/Three_Lives#c7">Three Lives… Three Fates… Three Futures</a></p>
<p class="toc1" id="t8"><a href="#/Part_I#c8">Part I: Seeds of Freedom</a></p>
<p class="toc" id="t9" style="margin-top: 0%;"><a href="#/One#c9">One</a></p>
<p class="toc" id="t10"><a href="#/Two#c10">Two</a></p>
<p class="toc" id="t11"><a href="#/Three#c11">Three</a></p>
<p class="toc" id="t12"><a href="#/Four#c12">Four</a></p>
<p class="toc" id="t13"><a href="#/Five#c13">Five</a></p>
<p class="toc" id="t14"><a href="#/Six#c14">Six</a></p>
<p class="toc" id="t15"><a href="#/Seven#c15">Seven</a></p>
<p class="toc" id="t16"><a href="#/Eight#c16">Eight</a></p>
<p class="toc" id="t17"><a href="#/Nine#c17">Nine</a></p>
<p class="toc" id="t18"><a href="#/Ten#c18">Ten</a></p>
<p class="toc" id="t19"><a href="#/Eleven#c19">Eleven</a></p>
<p class="toc" id="t20"><a href="#/Twelve#c20">Twelve</a></p>
<p class="toc1" id="t21"><a href="#/Part_II#c21">Part II: Roots of Strife</a></p>
<p class="toc" id="t22" style="margin-top: 0%;"><a href="#/Thirteen#c22">Thirteen</a></p>
<p class="toc" id="t23"><a href="#/Fourteen#c23">Fourteen</a></p>
<p class="toc" id="t24"><a href="#/Fifteen#c24">Fifteen</a></p>
<p class="toc" id="t25"><a href="#/Sixteen#c25">Sixteen</a></p>
<p class="toc" id="t26"><a href="#/Seventeen#c26">Seventeen</a></p>
<p class="toc" id="t27"><a href="#/Eighteen#c27">Eighteen</a></p>
<p class="toc" id="t28"><span href="#/Nineteen#c28" title="Link target outside of Sample">Nineteen</span></p>
<p class="toc" id="t29"><span href="#/Twenty#c29" title="Link target outside of Sample">Twenty</span></p>
<p class="toc" id="t30"><a href="#/TwentyOne#c30">Twenty-One</a></p>
<p class="toc" id="t31"><a href="#/TwentyTwo#c31">Twenty-Two</a></p>
<p class="toc" id="t32"><a href="#/TwentyThree#c32">Twenty-Three</a></p>
<p class="toc" id="t33"><a href="#/TwentyFour#c33">Twenty-Four</a></p>
<p class="toc1" id="t34"><span href="#/Part_III#c34" title="Link target outside of Sample">Part III: All Aboard</span></p>
<p class="toc" id="t35" style="margin-top: 0%;"><a href="#/TwentyFive#c35">Twenty-Five</a></p>
<p class="toc" id="t36"><a href="#/TwentySix#c36">Twenty-Six</a></p>
<p class="toc" id="t37"><a href="#/TwentySeven#c37">Twenty-Seven</a></p>
<p class="toc" id="t38"><a href="#/TwentyEight#c38">Twenty-Eight</a></p>
<p class="toc" id="t39"><a href="#/TwentyNine#c39">Twenty-Nine</a></p>
<p class="toc" id="t40"><span href="#/Thirty#c40" title="Link target outside of Sample">Thirty</span></p>
<p class="toc" id="t41"><a href="#/ThirtyOne#c41">Thirty-One</a></p>
<p class="toc" id="t42"><a href="#/ThirtyTwo#c42">Thirty-Two</a></p>
<p class="toc" id="t43"><a href="#/ThirtyThree#c43">Thirty-Three</a></p>
<p class="toc" id="t44"><a href="#/ThirtyFour#c44">Thirty-Four</a></p>
<p class="toc" id="t45"><a href="#/ThirtyFive#c45">Thirty-Five</a></p>
<p class="toc" id="t46"><a href="#/ThirtySix#c46">Thirty-Six</a></p>
<p class="toc" id="t47"><a href="#/ThirtySeven#c47">Thirty-Seven</a></p>
<p class="toc" id="t48"><a href="#/ThirtyEight#c48">Thirty-Eight</a></p>
<p class="toc1" id="t49"><span href="#/Part_IV#c49" title="Link target outside of Sample">Part IV: River Jordan</span></p>
<p class="toc" id="t50" style="margin-top: 0%;"><a href="#/ThirtyNine#c50">Thirty-Nine</a></p>
<p class="toc" id="t51"><span href="#/Forty#c51" title="Link target outside of Sample">Forty</span></p>
<p class="toc" id="t52"><a href="#/FortyOne#c52">Forty-One</a></p>
<p class="toc" id="t53"><a href="#/FortyTwo#c53">Forty-Two</a></p>
<p class="toc" id="t54"><a href="#/FortyThree#c54">Forty-Three</a></p>
<p class="toc" id="t55"><a href="#/FortyFour#c55">Forty-Four</a></p>
<p class="toc" id="t56"><a href="#/FortyFive#c56">Forty-Five</a></p>
<p class="toc" id="t57"><a href="#/FortySix#c57">Forty-Six</a></p>
<p class="toc" id="t58"><a href="#/FortySeven#c58">Forty-Seven</a></p>
<p class="toc" id="t59"><a href="#/FortyEight#c59">Forty-Eight</a></p>
<p class="toc" id="t60"><a href="#/FortyNine#c60">Forty-Nine</a></p>
<p class="toc" id="t61"><span href="#/Fifty#c61" title="Link target outside of Sample">Fifty</span></p>
<p class="toc" id="t62"><a href="#/FiftyOne#c62">Fifty-One</a></p>
<p class="toc" id="t63"><a href="#/FiftyTwo#c63">Fifty-Two</a></p>
<p class="toc" id="t64"><a href="#/FiftyThree#c64">Fifty-Three</a></p>
<p class="toc" id="t65"><a href="#/FiftyFour#c65">Fifty-Four</a></p>
<p class="toc" id="t66"><a href="#/FiftyFive#c66">Fifty-Five</a></p>
<p class="toc1" id="t67"><span href="#/Families#c67" title="Link target outside of Sample">Families in <i>Dreams of Freedom</i></span></p>
<p class="toc1" id="t68" style="margin-top: 0%;"><span href="#/Endnotes#c68" title="Link target outside of Sample">Endnotes</span></p>
</div>
</div></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// FM.vue?1557496c